import { useEffect } from 'react'

export const useOnEscPress = ({
  onEscPress,
}: {
  onEscPress: () => void
}): void => {
  useEffect(() => {
    const callFunction = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onEscPress()
      }
    }

    document.addEventListener('keydown', callFunction, false)
    return () => {
      document.removeEventListener('keydown', callFunction, false)
    }
  }, [onEscPress])
}
